<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES75UC4']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['40'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codobf" name="coddesc_codobf">{{ detail.tab1.codobf }} - {{ detail.tab1.desc_codobf }}</div>
                </div>
              </div>
          
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['50'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="desc_typrelate" name="desc_typrelate">{{ detail.tab1.desc_typrelate }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['170'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="nameobf" name="nameobf">{{ detail.tab1.nameobf }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['60'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="amtreq" name="amtreq">{{ detail.tab1.amtreq }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['70'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="desc_codunit" name="desc_codunit">{{ detail.tab1.desc_codunit }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['80'] }}</div>
                <div class="detail-right ">
                  <input type="radio" value="1" v-model="detail.tab1.typpay" disabled="disabled"> <span class="radio-text">{{ labels['HRES75UC4']['90'] }}</span>
                  <input type="radio" value="2" v-model="detail.tab1.typpay" disabled="disabled"> <span class="radio-text">{{ labels['HRES75UC4']['100'] }}</span>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['180'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="dtepay" name="dtepay">{{ setDateOutput(detail.tab1.dtepay) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['110'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50">
                        <a :href="baseURL + detail.tab1.path_filenam1" target="_blank">{{ detail.tab1.filenam1 }}</a>
                    </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['120'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50">
                        <a :href="baseURL + detail.tab1.path_filenam2" target="_blank">{{ detail.tab1.filenam2 }}</a>
                    </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['130'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50">
                        <a :href="baseURL + detail.tab1.path_filenam3" target="_blank">{{ detail.tab1.filenam3 }}</a>
                    </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC4']['140'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50 txtarea-width response-full-width" id="desnote" name="desnote">{{ detail.tab1.desnote }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
 
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES75UC3']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">
       
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC3']['10'] }}</div>
                <div class="detail-right">

                    <div class="detail-text width-50" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC3']['30'] }}</div>
                <div class="detail-right">

                    <div class="detail-text width-50" id="coddesc_codobf" name="coddesc_codobf">{{ detail.tab1.codobf }} - {{ detail.tab1.desc_codobf }}</div>
                </div>
              </div>
            </div>
    
            <hrms-table :columns="tab2Table" :data="detail.tab2.table" />
                   
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES75UC6']['0'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="coddesc_codobf" name="coddesc_codobf">{{ detail.tab3.codobf }} - {{ detail.tab3.desc_codobf }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50" id="desc_codunit" name="desc_codunit">{{ detail.tab3.desc_codunit }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['40'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-50 txtarea-width response-full-width" id="syncond" name="syncond">{{ detail.tab3.syncond }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['50'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="desc_flglimit" name="desc_flglimit">{{ detail.tab3.desc_flglimit }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['60'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="desc_typrelate" name="desc_typrelate">{{ detail.tab3.desc_typrelate }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['70'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="dte_btw" name="dte_btw">{{ setDateOutput(detail.tab3.dtestrt) }} - {{ setDateOutput(detail.tab3.dteend) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['90'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="amtwidrw" name="amtwidrw">{{ detail.tab3.amtwidrw }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['100'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="qtywidrw" name="qtywidrw">{{ detail.tab3.qtywidrw }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['110'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="acc_amt" name="acc_amt">{{ detail.tab3.acc_amt }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['120'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="acc_num" name="acc_num">{{ detail.tab3.acc_num }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['130'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="available" name="available">{{ detail.tab3.available }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES75UC6']['140'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-40" id="acc_all" name="acc_all">{{ detail.tab3.acc_all }}</div>
                </div>
              </div>

            </div>            
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import env from 'src/../env.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres75u-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'tab2Table', 'data', 'nowLang' ],
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?0677a086